import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import GanhadorBackup from "../../assets/images/ganhador-backup.jpg";
import Ganhador0326 from "../../assets/images/ganhador-0326.jpg";
import Ganhador0426 from "../../assets/images/ganhador-0426.jpg";
import Ganhador0526 from "../../assets/images/ganhador-0526.jpg";
import Ganhador0626 from "../../assets/images/ganhador-0626.jpg";
import Ganhador0726 from "../../assets/images/ganhador-0726.jpg";
import AccordionAnt from "../AccordionAnt";
import "./Ganhadores.css";

export default function Ganhadores() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div>
      <div className="ganhadores-first-divider" />
      <Container fluid className="ganhadores-section">
        <Row id="ganhadores">
          <Col className="title-col-light">
            <h2 className="section-title-light">GANHADORES 2026</h2>
          </Col>
        </Row>
        <Container>
          <Row>
            <Carousel
              activeIndex={index}
              onSelect={handleSelect}
              touch={true}
              controls={true}
              indicators={true}
            >
              <Carousel.Item>
                <Row>
                  <Col className="ganhadores-carousel-first-col">
                    <img
                      src={Ganhador0726}
                      alt="Ganhador de Julho"
                      className="ganhadores-carousel-img"
                    />
                  </Col>
                  <Col className="ganhadores-carousel-second-col">
                    <Row>
                      <h2>Julho</h2>
                    </Row>
                    <Row>
                      <h3>FLAVIANE REGINA DIAS</h3>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          <span>Prêmio: </span>Geladeira da marca Consul
                          <br />
                          modelo Frost Free 410 L
                        </p>
                        <p>
                          <span>Cidade: </span>São Leopoldo
                        </p>
                        <p>
                          <span>Data do sorteio: </span>11/07/2026
                        </p>
                        <p>
                          <span>Número sorteado: </span>069822
                        </p>
                        <p>
                          <span>Número contemplado: </span>069818
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Carousel.Item>
              <Carousel.Item>
                <Row>
                  <Col className="ganhadores-carousel-first-col">
                    <img
                      src={Ganhador0626}
                      alt="Ganhador de Junho"
                      className="ganhadores-carousel-img"
                    />
                  </Col>
                  <Col className="ganhadores-carousel-second-col">
                    <Row>
                      <h2>Junho</h2>
                    </Row>
                    <Row>
                      <h3>JESSICA TRIERVEILER</h3>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          <span>Prêmio: </span>Ar-condicionado da marca
                          Electrolux
                          <br />
                          modelo JI12R Quente e frio, 12.000 btus
                        </p>
                        <p>
                          <span>Cidade: </span>Novo Hamburgo
                        </p>
                        <p>
                          <span>Data do sorteio: </span>13/06/2026
                        </p>
                        <p>
                          <span>Número sorteado: </span>181759
                        </p>
                        <p>
                          <span>Número contemplado: </span>181723
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Carousel.Item>
              <Carousel.Item>
                <Row>
                  <Col className="ganhadores-carousel-first-col">
                    <img
                      src={Ganhador0526}
                      alt="Ganhador de Maio"
                      className="ganhadores-carousel-img"
                    />
                  </Col>
                  <Col className="ganhadores-carousel-second-col">
                    <Row>
                      <h2>Maio</h2>
                    </Row>
                    <Row>
                      <h3>SANDRA TEREZINHA FINKEN</h3>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          <span>Prêmio: </span>Televisor AOC
                          <br />
                          Smart 43 polegadas
                        </p>
                        <p>
                          <span>Cidade: </span>Novo Hamburgo
                        </p>
                        <p>
                          <span>Data do sorteio: </span>09/05/2026
                        </p>
                        <p>
                          <span>Número sorteado: </span>107327
                        </p>
                        <p>
                          <span>Número contemplado: </span>107329
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Carousel.Item>
              <Carousel.Item>
                <Row>
                  <Col className="ganhadores-carousel-first-col">
                    <img
                      src={Ganhador0426}
                      alt="Ganhador de Abril"
                      className="ganhadores-carousel-img"
                    />
                  </Col>
                  <Col className="ganhadores-carousel-second-col">
                    <Row>
                      <h2>Abril</h2>
                    </Row>
                    <Row>
                      <h3>ARLINDO COLISSE</h3>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          <span>Prêmio: </span>Geladeira da marca Consul
                          <br />
                          modelo Frost Free 410 L
                        </p>
                        <p>
                          <span>Cidade: </span>Novo Hamburgo
                        </p>
                        <p>
                          <span>Data do sorteio: </span>11/04/2026
                        </p>
                        <p>
                          <span>Número sorteado: </span>010742
                        </p>
                        <p>
                          <span>Número contemplado: </span>010757
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Carousel.Item>
              <Carousel.Item>
                <Row>
                  <Col className="ganhadores-carousel-first-col">
                    <img
                      src={Ganhador0326}
                      alt="Ganhador de Março"
                      className="ganhadores-carousel-img"
                    />
                  </Col>
                  <Col className="ganhadores-carousel-second-col">
                    <Row>
                      <h2>Março</h2>
                    </Row>
                    <Row>
                      <h3>MARIA ARABEL CHAGAS</h3>
                    </Row>
                    <Row>
                      <Col>
                        <p>
                          <span>Prêmio: </span>Ar-condicionado da marca
                          Electrolux
                          <br />
                          modelo JI12R Quente e frio, 12.000 btus
                        </p>
                        <p>
                          <span>Cidade: </span>Novo Hamburgo
                        </p>
                        <p>
                          <span>Data do sorteio: </span>14/03/2026
                        </p>
                        <p>
                          <span>Número sorteado: </span>033267
                        </p>
                        <p>
                          <span>Número contemplado: </span>033278
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Carousel.Item>
            </Carousel>
          </Row>
        </Container>
      </Container>
      <div className="ganhadores-last-divider" />
      <AccordionAnt title="GANHADORES 2025" />
    </div>
  );
}
